import React from 'react';

export default function useStepWizard(steps, activeIndex, validColor = "green", activeColor = "red", inactiveColor = "gray", bgColor = "white") {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: "flex-start", width: "100%", flexWrap: "wrap", gap: "15px", padding:"15px" }}>
            {steps.map((step, index) => (
                <div
                    key={index}
                    style={{
                        width:"120px",
                        display: 'flex',
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px"
                    }}>
                    <div
                        style={{
                            border: index === activeIndex - 1 ? `5px solid ${activeColor}` : ( index < activeIndex ? `5px solid ${validColor}` : `5px solid ${inactiveColor}`) ,
                            display: 'flex',
                            width: "65px",
                            height: "65px",
                            borderRadius: '100%',
                            background: bgColor,
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.8)'
                        }}
                    >
                        <div style={{ textAlign: "center" }}>
                            {step.icone && <div>{step.icone}</div>}
                        </div>
                    </div>
                    <div style={{ textAlign: "center" }}>{step.nome}</div>
                </div>
            ))}
        </div>
    )
}
